import { useState } from 'react'
import { Container, Row, Col, Card, Tabs, Tab } from 'react-bootstrap'
import { useAppStore } from '../stores/appStore'
import TaskGroupManager from '../components/TaskGroupManager'
import UserGroupManager from '../components/UserGroupManager'

const GroupManagement = () => {
  const { taskManager } = useAppStore()
  const [activeTab, setActiveTab] = useState('task-groups')

  return (
    <Container fluid>
      {/* 页面标题 */}
      <Row className="mb-4">
        <Col xs={12}>
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="card-title text-primary mb-1">组管理</h4>
                  <p className="card-text text-muted mb-0">创建和管理任务组、用户组，提高任务执行效率</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* 组管理标签页 */}
      <Row>
        <Col xs={12}>
          <Tabs 
            activeKey={activeTab} 
            onSelect={setActiveTab} 
            className="mb-4"
          >
            <Tab eventKey="task-groups" title="任务组管理">
              <TaskGroupManager taskManager={taskManager} />
            </Tab>
            <Tab eventKey="user-groups" title="用户组管理">
              <UserGroupManager />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </Container>
  )
}

export default GroupManagement
